import { render, staticRenderFns } from "./user-followup-2-1.vue?vue&type=template&id=ca51eb96"
import script from "./user-followup-2-1.vue?vue&type=script&lang=js"
export * from "./user-followup-2-1.vue?vue&type=script&lang=js"
import style0 from "./user-followup-2-1.vue?vue&type=style&index=0&id=ca51eb96&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports